import { Break, Space, Typography } from '../../../../../components/core-v2'
import Icon from '../../../../../components/core-v2/atoms/Icon'
import LinkIcon from '../../../../../components/core-v2/molecules/linkIcon'

export type PortfolioTitleProps = {
  onClickChooseAnotherPorfolio: () => void
  title: string
}

export function PortfolioTitle({ onClickChooseAnotherPorfolio, title }: PortfolioTitleProps) {
  return (
    <>
      <Space mx={5} my={6}>
        <Space isflex alignItems="center" flexDirection="column">
          <Space mb={5}>
            <Typography fontSize="15px" fontWeight="800" variant="b3">
              {title}
            </Typography>
          </Space>
          <LinkIcon
            disabled={false}
            icon={<Icon name="search" size="default" />}
            iconPosition="left"
            text="Choose another portfolio"
            onClick={() => onClickChooseAnotherPorfolio()}
          />
        </Space>
      </Space>
      <Space mx={5} pb={5}>
        <Break />
      </Space>
    </>
  )
}
